import React, { useEffect, useState } from "react";
import { Row, Col, Button, Alert } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faCheck } from "@fortawesome/free-solid-svg-icons";

//API
import fiscalizacao_api from "../../../../api/fiscalizacao_api";

//Helpers
import { montarPayloadFiscalizacao } from "../../../../helpers/fiscalizacao";
import {
  montarFichaFiscalizacaoPreview,
  montarFichaInfracaoPreview,
} from "../helpers/montarFichaPreview";

//Components
import AutoDeFiscalizacao from "../../../Shared/AutoDeFiscalizacao";
import FichaInfracao from "../../../Shared/FichaInfracao";

function PreviaFiscalizacao({
  execucaoFiscalizacao,
  tipoFiscalizacao,
  formulario,
  solicitacaoImages,
  onEditar,
  onConcluir,
  setShowButtons,
}) {
  const [carregando, setCarregando] = useState(true);
  const [infracoes, setInfracoes] = useState([]);
  const [erroPreview, setErroPreview] = useState(null);

  const carregarPreview = () => {
    setCarregando(true);
    setErroPreview(null);
    fiscalizacao_api
      .preview(montarPayloadFiscalizacao(execucaoFiscalizacao))
      .then((response) => setInfracoes(response.data?.infracoes ?? []))
      .catch(() =>
        setErroPreview(
          "Não foi possível carregar a prévia dos autos de infração. Você ainda pode revisar os dados abaixo e concluir normalmente."
        )
      )
      .finally(() => setCarregando(false));
  };

  useEffect(() => {
    setShowButtons(false);
    carregarPreview();
    // Restaura os botões do Stepper ao sair da Prévia por qualquer caminho (Editar incluso).
    return () => setShowButtons(true);
  }, []);

  return (
    <div>
      {carregando ? (
        <p>Carregando prévia...</p>
      ) : erroPreview ? (
        <Row className="mb-4">
          <Col md="12">
            <Alert color="warning">{erroPreview}</Alert>
          </Col>
        </Row>
      ) : (
        <>
          <AutoDeFiscalizacao
            preview
            fichaExterna={montarFichaFiscalizacaoPreview({
              execucaoFiscalizacao,
              tipoFiscalizacao,
              formulario,
              infracoes,
              solicitacaoImages,
            })}
          />

          {infracoes.map((infracaoPreview, key) => (
            <div key={key} className="mt-4">
              <FichaInfracao
                preview
                fichaExterna={montarFichaInfracaoPreview({
                  execucaoFiscalizacao,
                  tipoFiscalizacao,
                  infracaoPreview,
                })}
              />
            </div>
          ))}
        </>
      )}

      <div className="d-flex align-items-center justify-content-center mt-4">
        <Button
          outline
          color="secondary"
          className="me-4 bg-gradient d-flex align-items-center"
          onClick={onEditar}
        >
          <FontAwesomeIcon icon={faPen} className="me-3" /> Editar
        </Button>
        <Button
          color="success"
          className="bg-gradient d-flex align-items-center"
          onClick={onConcluir}
        >
          <FontAwesomeIcon icon={faCheck} className="me-3" /> Concluir
        </Button>
      </div>
    </div>
  );
}

export default PreviaFiscalizacao;
